import type { FaireThemeEntity } from "../../entity_types/theme";

export const non_toxic_family_first_aid_v3: FaireThemeEntity = {
  token: "non-toxic-family-first-aid-v3",
  type: "theme",
  name: "Non-Toxic Family First Aid (v3)",
  description: "Gentle, plant-based solutions for the whole family, from soothing shower gels to child-safe inflammation support.",
  teaser: "As a retailer that stocks babygowns, kids' makeup, and children's sweatshirts, you serve a demographic of parents looking for safe, high-quality products for their children.",
  detail: "The recent order payload specifically includes a Children's Relief oral supplement and a Hair Spritz noted as safe for kids, highlighting your commitment to family-oriented wellness.",
  bgColor: "#E6D5C3",
  tileBgColor: "#3a4c6b",
  exactProducts: true,
  retailerToken: "r_vywa5ks4ga",
  productTokens: [
    "p_df9jt0hwsn",
    "p_3egli7abrl",
    "p_9qkh2kdq7t",
    "p_usv4xb8vw4",
    "p_rfvj5dhfm4",
    "p_ajbkkrgz4g",
    "p_nm8cq573vu",
    "p_qm726sqfwg",
    "p_cbhp68psak",
    "p_h6xg264682",
    "p_xmedg6qxyq",
    "p_4b3shbnbyy",
    "p_tjqnuvxgws",
    "p_rb9gr667zc",
    "p_9bqgaj98fb",
    "p_nj95wd456k",
    "p_6jbvquftkm",
    "p_2rr2vul1x9",
    "p_c1qa5xu0gx",
    "p_ca8vg3knqx",
    "p_yhnn7g48qg",
    "p_7ujrkwby4a",
    "p_3mdcqpx38e",
    "p_41i9adts",
    "p_zbwm3jf98y",
    "p_3fbndntsav",
    "p_122ivjfkd4",
    "p_zd34cmnatn",
    "p_jkkhqc2dah",
    "p_yzd8rzsp5z",
    "p_hu2ux7cnp8",
    "p_eu7d23u6sg",
    "p_s9vkfcbt95",
    "p_xtsweuwr4s",
    "p_6h33ns0q1u",
    "p_2lptpbe81p",
    "p_89hzri8q58",
    "p_25xbioun8c",
    "p_3hbm34s26f",
    "p_mzkgdvvaye",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-26T00:00:00Z",
    importedBy: "manual-v3-import",
  },
};
